import { render, staticRenderFns } from "./NeoparentPatientSelector.vue?vue&type=template&id=0b3a61a1&scoped=true"
import script from "./NeoparentPatientSelector.vue?vue&type=script&lang=js"
export * from "./NeoparentPatientSelector.vue?vue&type=script&lang=js"
import style0 from "./NeoparentPatientSelector.vue?vue&type=style&index=0&id=0b3a61a1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3a61a1",
  null
  
)

export default component.exports